import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';

export default class TMACMSModel implements CMSModel {
  registration = '';
  appointment_confirmed = '';
  received_by_vac = '';
  application_documentation_confirmed = '';
  csl_appointment_confirmed = '';
  application_transferred_to_dmc = '';
  decision_made = '';
  passback_from_consulate = '';
  passport_returned = '';
  instruction_alert = '';
  status_done = '';
  status_undone = '';
  status_pending = '';
  status_attention = '';

  map(obj: any): void {
    this.registration = _.get(obj, 'translation[0].registration', 'registration');
    this.application_transferred_to_dmc = _.get(obj, 'translation[0].application_transferred_to_dmc', 'application_transferred_to_dmc');
    this.appointment_confirmed = _.get(obj, 'translation[0].appointment_confirmed', 'appointment_confirmed');
    this.received_by_vac = _.get(obj, 'translation[0].received_by_vac', 'received_by_vac');
    this.application_documentation_confirmed = _.get(
      obj,
      'translation[0].application_documentation_confirmed',
      'application_documentation_confirmed'
    );
    this.csl_appointment_confirmed = _.get(obj, 'translation[0].csl_appointment_confirmed', 'csl_appointment_confirmed');
    this.decision_made = _.get(obj, 'translation[0].decision_made', 'decision_made');
    this.passback_from_consulate = _.get(obj, 'translation[0].passback_from_consulate', 'passback_from_consulate');
    this.passport_returned = _.get(obj, 'translation[0].passport_returned', 'passport_returned');
    this.instruction_alert = _.get(obj, 'translation[0].instruction_alert', 'instruction_alert');
    this.status_done = _.get(obj, 'translation[0].status_done', 'status_done');
    this.status_undone = _.get(obj, 'translation[0].status_undone', 'status_undone');
    this.status_pending = _.get(obj, 'translation[0].status_pending', 'status_pending');
    this.status_attention = _.get(obj, 'translation[0].status_attention', 'status_attention');
  }
}
